// Native (Android kiosk) → JS callbacks for the new-menu app.
// The native IdleManager / StripeFunctions call these via WebView.evaluateJavascript.

import {useCartStore} from "@/new-menu/stores/cart.store";
import {refreshKioskStripeConnectionToken} from "@/new-menu/helpers/kioskStripe";

export function registerKioskCallbacks(idleWarningPopup) {
	window.qromoKiosk = window.qromoKiosk || {};

	window.qromoKiosk.showIdleWarning = function (graceSeconds) {
		idleWarningPopup?.show?.(graceSeconds);
	};

	window.qromoKiosk.dismissIdleWarning = function () {
		idleWarningPopup?.dismiss?.();
	};

	window.qromoKiosk.onPaymentResult = function (status) {
		useCartStore().handleKioskPaymentResult(status);
	};

	window.qromoKiosk.refreshStripeConnectionToken = function () {
		refreshKioskStripeConnectionToken();
	};
}
